import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Stepper');

function Stepper(props) {
    const { stepperValue, onChange, min, max, orientation, className, step, messages, disabled } = props;
    const { container, firstButton, value, secondButton } = className;

    return (
        <span className={bem('container', orientation, container)}>
            <button
                role="button"
                aria-label={messages.quantity.ctaButtons.subtractQuantity()}
                className={bem('button', 'minus', firstButton)}
                type="button"
                disabled={disabled || stepperValue <= min}
                onClick={() => onChange(stepperValue - step)}
            />
            <span className={bem('value', null, value)}>{stepperValue}</span>
            <button
                role="button"
                aria-label={messages.quantity.ctaButtons.addQuantity()}
                className={bem('button', 'plus', secondButton)}
                type="button"
                disabled={disabled || stepperValue >= max}
                onClick={() => onChange(stepperValue + step)}
            />
        </span>
    );
}

Stepper.propTypes = {
    stepperValue: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    step: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.object,
    orientation: PropTypes.string,
    disabled: PropTypes.bool,
    messages: PropTypes.shape({
        quantity: PropTypes.shape({
            ctaButtons: PropTypes.shape({
                subtractQuantity: PropTypes.func.isRequired,
                addQuantity: PropTypes.func.isRequired,
            }),
        }),
    }),
};

Stepper.defaultProps = {
    min: 1,
    max: Number.MAX_SAFE_INTEGER,
    initialQuantity: 1,
    step: 1,
    orientation: 'horizontal',
    className: {},
};

export default Stepper;
